import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import PhoneFormatter from '@/util/PhoneFormatter';
import { copyToClipboard } from '@/util/Clipboard';

@Component
export default class PhoneFormatMixin extends Vue {
    /**
     * Copies a phone number to clipboard in Twilio-compatible E.164 format (+15551234567).
     *
     * @param phone - The phone number in any format
     */
    copy(phone: string): void {
        if (!phone) return;
        void copyToClipboard(PhoneFormatter.formatForTwilio(phone));
    }

    /**
     * Copies text to clipboard as-is.
     *
     * @param text - The text to copy
     */
    copyText(text: string): void {
        if (!text) return;
        void copyToClipboard(text);
    }


    formatPhone(phone: string | null | undefined): string {
        return PhoneFormatter.formatForDisplay(phone);
    }

    formatPhoneForTwilio(phone: string | null | undefined): string {
        return PhoneFormatter.formatForTwilio(phone);
    }
}
